import { IconName } from '@infotech-soe/erp-ui-kit';
import { CommandHotKey, THotKey } from '@infotech-soe/metaschema';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import { CommandName } from '../CommandViewModel';
import { UserInteractor, UserInteractorType } from '../UserInteractor';

import CategoryCommand, { RefreshStrategy } from './CategoryCommand';

class UpdateDatasetCommand extends CategoryCommand<void> {
  public static COMMAND_NAME = 'update' as const;

  public async execute(): Promise<void> {
    // not implemented
  }

  public getIcon(): IconName {
    return 'refresh';
  }

  public getHotKey(): THotKey {
    return CommandHotKey.UpdateDataset;
  }

  public getName(): CommandName {
    return UpdateDatasetCommand.COMMAND_NAME;
  }

  public async getInitialArgs(): Promise<void> {
    // not implemented
  }

  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.UPDATE,
    };
  }

  public async getUserInteractor(): Promise<UserInteractor> {
    return {
      type: UserInteractorType.NONE,
    };
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.ALL;
  }
}

export default UpdateDatasetCommand;
